import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 48px;
  border: 2px solid ${({ theme }) => theme.colors.divider.primary};
  border-radius: 15px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
`;

export const Input = styled.input`
  border: none;
  background-color: transparent;
  padding: 10px;
  outline: none;
  width: 100%;
`;
